import { render, staticRenderFns } from "./AdminProjectsAdd.vue?vue&type=template&id=5f1545f8&"
import script from "./AdminProjectsAdd.vue?vue&type=script&lang=js&"
export * from "./AdminProjectsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports